import { mapEnumToOptions } from '@unistocks/shared/utils/enum-utils';

export enum EventViewLayout {
  List = 1,
  Carousel = 3
}

export const eventViewLayoutOptions = mapEnumToOptions(EventViewLayout, 'EventViewLayout');
